import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export const CTABanner = () => (
    <section className="border-t border-slate-800/70">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-12 lg:py-28">
            <Reveal>
                <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
                    <div className="lg:col-span-8">
                        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-blue-400">
                            Confidential Inquiry
                        </p>
                        <h2 className="mt-5 max-w-2xl font-serif text-3xl font-medium leading-[1.15] tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
                            Every engagement begins with a private conversation.
                        </h2>
                    </div>
                    <div className="lg:col-span-4 lg:text-right">
                        <Link
                            to="/contact"
                            data-testid="cta-contact-link"
                            className="group inline-flex items-center gap-3 border border-slate-700 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-200 transition-all duration-300 hover:border-blue-500 hover:text-white"
                        >
                            Contact the Firm
                            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                        </Link>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
